import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { utils } from '../../lib'

class ButtonData extends React.Component {

  onClick = e => {
    e.preventDefault()
    e.stopPropagation()
    this.props.onClick(this.props.data, e)
  }

  render() {
    const filtered = utils.filter(this.props, { type: true, onClick: true, data: true })

    if (this.props.type === 'button') {
      return <Button {...filtered} onClick={this.onClick}>{this.props.children}</Button>
    } else {
      return <span {...filtered} onClick={this.onClick}>{this.props.children}</span>
    }
  }
}

ButtonData.defaultProps = {
  type: 'icon',
  data: {},
  onClick: ()=> {},
}
ButtonData.propTypes = {
  type: PropTypes.oneOf(['icon', 'text', 'button']),
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClick: PropTypes.func,
}

export default ButtonData



// WEBPACK FOOTER //
// ./src/components/widgets/ButtonData.js